function getTranslations(translations) {
  return Object.entries(translations).reduce((acc, [key, translation]) => {
    acc[key] = {
      name: translation.name,
      description: translation.description,
      meta_title: translation.metaTitle,
      meta_description: translation.metaDescription,
      short_description: translation.shortDescription,
      reviews: translation.reviews,
      speed: translation.speed,
      start_time: translation.startTime,
    };

    return acc;
  }, {});
}

function getPackagesContent(packageContents) {
  return packageContents.map((packageContent) => ({
    service_id: packageContent.id,
    quantity: packageContent.quantity,
    is_displayable: packageContent.isDisplayable,
  }));
}

export function createPackageStoreRequest(data) {
  return {
    sync: data.sync,
    provider_id: data.providerId,
    network_id: data.networkId,
    translations: getTranslations(data.translations),
    is_enabled: data.isEnabled,
    type: data.type,
    restricted_access: data.restrictedAccess,
    fixed_cost: data.fixedCost,
    discount_percent: data.discountPercent,
    package_contents: getPackagesContent(data.packageContents),
    service_type_id: data.serviceTypeId,
  };
}

export function createPackageUpdateRequest(data) {
  return {
    sync: data.sync,
    translations: getTranslations(data.translations),
    is_enabled: data.isEnabled,
    type: data.type,
    restricted_access: data.restrictedAccess,
    fixed_cost: data.fixedCost,
    discount_percent: data.discountPercent,
    package_contents: getPackagesContent(data.packageContents),
    service_type_id: data.serviceTypeId,
  };
}
